"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageGallery = void 0;
var solid_1 = require("@heroicons/react/24/solid");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var ImageGallery = /** @class */ (function (_super) {
    __extends(ImageGallery, _super);
    function ImageGallery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mouseHandleRef = react_1.default.createRef();
        _this.pos = { top: 0, left: 0, x: 0, y: 0 };
        _this.intervalId = null;
        _this.state = { imageUrl: [], selectedImageUrl: "" };
        _this.handleMouseDown = function (e) {
            if (_this.mouseHandleRef.current) {
                _this.mouseHandleRef.current.style.cursor = "grabbing";
                _this.mouseHandleRef.current.style.userSelect = "none";
                _this.pos = {
                    left: _this.mouseHandleRef.current.scrollLeft,
                    top: _this.mouseHandleRef.current.scrollTop,
                    x: e.clientX,
                    y: e.clientY,
                };
                _this.mouseHandleRef.current.addEventListener("mousemove", _this.handleMouseMove);
                _this.mouseHandleRef.current.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseMove = function (e) {
            if (_this.mouseHandleRef.current) {
                var dx = e.clientX - _this.pos.x;
                var dy = e.clientY - _this.pos.y;
                _this.mouseHandleRef.current.scrollTop = _this.pos.top - dy;
                _this.mouseHandleRef.current.scrollLeft = _this.pos.left - dx;
            }
        };
        _this.handleMouseUp = function () {
            if (_this.mouseHandleRef.current) {
                _this.mouseHandleRef.current.style.cursor = "grab";
                _this.mouseHandleRef.current.style.removeProperty("user-select");
                _this.mouseHandleRef.current.removeEventListener("mousemove", _this.handleMouseMove);
                _this.mouseHandleRef.current.removeEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleNextImage = function () {
            var _a;
            if (_this.intervalId)
                clearInterval(_this.intervalId);
            var currentImageIndex = (_this.props.currentImage + 1) % _this.props.imageGallery.length;
            _this.props.handleSetCurrentImage(currentImageIndex);
            _this.intervalId = setInterval(_this.handleNextImage, (_a = _this.props.imageTransitionMS) !== null && _a !== void 0 ? _a : 5000);
        };
        _this.handlePrevImage = function () {
            var _a;
            if (_this.intervalId)
                clearInterval(_this.intervalId);
            var currentImageIndex = _this.props.currentImage === 0
                ? _this.props.imageGallery.length - 1
                : _this.props.currentImage - 1;
            _this.props.handleSetCurrentImage(currentImageIndex);
            _this.intervalId = setInterval(_this.handleNextImage, (_a = _this.props.imageTransitionMS) !== null && _a !== void 0 ? _a : 5000);
        };
        _this.handleImageGallery = function () {
            var imageUrlList = _this.props.imageGallery.map(function (eachImage) { return eachImage.imageUrl; });
            _this.setState({ imageUrl: imageUrlList });
        };
        _this.handleSwitchImage = function (imageUrl, index) {
            var _a;
            if (_this.intervalId)
                clearInterval(_this.intervalId);
            _this.setState({
                selectedImageUrl: imageUrl,
            });
            _this.props.handleSetCurrentImage(index);
            _this.setState({
                selectedImageUrl: "",
            });
            _this.intervalId = setInterval(_this.handleNextImage, (_a = _this.props.imageTransitionMS) !== null && _a !== void 0 ? _a : 5000);
        };
        _this.renderImageGallery = function () {
            var defaultClassName = "".concat(_this.props.eachImageClassName, " max-h-20 sm:max-h-28 hover:cursor-pointer min-w-[35vw] sm:min-w-[20vw] object-cover object-center");
            var imageGallery = [];
            if (_this.state.imageUrl.length > 0) {
                _this.state.imageUrl.map(function (eachUrl, index) {
                    return imageGallery.push(react_1.default.createElement("img", { key: index, src: eachUrl, alt: eachUrl, className: defaultClassName, draggable: false, onClick: function () { return _this.handleSwitchImage(eachUrl, index); }, onMouseEnter: function () { return _this.handleSwitchImage(eachUrl, index); } }));
                });
            }
            return imageGallery;
        };
        _this.renderSelectedImageComponent = function () {
            var _a;
            return (react_1.default.createElement("div", { className: "h-[300px] sm:h-[500px] relative min-w-[40vw] min-h-[15vh] sm:min-h-[30vh]" },
                react_1.default.createElement("img", { src: _this.state.selectedImageUrl ||
                        _this.state.imageUrl[_this.props.currentImage], className: (_a = _this.props.currentImageClassName) !== null && _a !== void 0 ? _a : "w-full h-full object-contain object-center", alt: "", draggable: false }),
                react_1.default.createElement("img", { src: _this.state.selectedImageUrl ||
                        _this.state.imageUrl[_this.props.currentImage], alt: "", draggable: false, className: "absolute top-0 blur-lg -z-[5] w-full h-full object-cover" }),
                react_1.default.createElement("button", { className: "absolute bottom-0 left-0 top-0 z-[5] flex w-[10%] items-center justify-center text-white opacity-50 transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:opacity-90 motion-reduce:transition-none", type: "button", onClick: _this.handlePrevImage },
                    react_1.default.createElement(solid_1.ChevronLeftIcon, { className: "w-6 h-6 sm:w-10 sm:h-10 md:w-12 md:h-12" })),
                react_1.default.createElement("button", { className: "absolute bottom-0 right-0 top-0 z-[5] flex w-[10%] items-center justify-center text-white opacity-50 transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:opacity-90 motion-reduce:transition-none", type: "button", onClick: _this.handleNextImage },
                    react_1.default.createElement(solid_1.ChevronRightIcon, { className: "w-6 h-6 sm:w-10 sm:h-10 md:w-12 md:h-12" }))));
        };
        return _this;
    }
    ImageGallery.prototype.componentDidMount = function () {
        var _a;
        this.intervalId = setInterval(this.handleNextImage, (_a = this.props.imageTransitionMS) !== null && _a !== void 0 ? _a : 5000);
        this.handleImageGallery();
        if (this.mouseHandleRef.current) {
            this.mouseHandleRef.current.addEventListener("mousedown", this.handleMouseDown);
        }
    };
    ImageGallery.prototype.componentWillUnmount = function () {
        if (this.intervalId)
            clearInterval(this.intervalId);
        if (this.mouseHandleRef.current) {
            this.mouseHandleRef.current.removeEventListener("mousedown", this.handleMouseDown);
        }
    };
    ImageGallery.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "overflow-hidden" },
            this.renderSelectedImageComponent(),
            react_1.default.createElement("div", { ref: this.mouseHandleRef, className: "chat-scrollbar flex overflow-x-auto" }, this.renderImageGallery())));
    };
    return ImageGallery;
}(react_1.Component));
exports.ImageGallery = ImageGallery;
//# sourceMappingURL=index.js.map